function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMidL(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 720",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mid_l") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Bg"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "82.52 413.36 100.92 170.49 137.72 137.38 157.58 0 0 0 0 720 213.27 720 130.36 512.71 82.52 413.36",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1280 0 1051.97 0 1197.48 394.96 1081.71 720 1280 720 1280 0",
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "291.08 648.02 316.63 720 316.63 720 232.16 482.04 291.08 648.02",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "778.55 720 778.55 720 771.86 646.4 778.55 720",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "688.45 538.47 771.86 646.4 645.93 482.04 688.45 538.47",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.12 203.61 217.44 64.19 264.87 141.06 304.12 203.61",
    style: {
      fill: "#c6c6c6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.35 0 245.42 0 217.44 64.19 284.35 0",
    style: {
      fill: "#f2f2f2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "688.45 538.47 580.51 575.26 433.32 575.26 451.3 720 778.55 720 771.86 646.4 688.45 538.47",
    style: {
      fill: "#cbcbcb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "771.86 646.4 778.55 720 953.45 720 938.67 550.73 771.86 646.4",
    style: {
      fill: "#cacaca"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1029.88 720 1060.71 720 1125.11 513.93 1051.52 482.04 1029.88 720",
    style: {
      fill: "#cecece"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1125.11 513.93 1060.71 720 1081.71 720 1197.48 394.96 1125.11 513.93",
    style: {
      fill: "#d4d4d4"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "938.67 550.73 953.45 720 1029.88 720 1051.52 482.04 938.67 550.73",
    style: {
      fill: "#cdcdcd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.16 482.04 316.63 720 451.3 720 433.32 575.26 232.16 482.04",
    style: {
      fill: "#ccc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "262.26 720 316.63 720 291.08 648.02 262.26 720",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "232.16 482.04 183.1 464.87 173.29 507.39 255.07 720 262.26 720 291.08 648.02 232.16 482.04",
    style: {
      fill: "#d0d0d0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.29 507.39 130.77 482.04 82.52 413.36 130.36 512.71 213.27 720 254.58 720 173.29 507.39",
    style: {
      fill: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.29 507.39 254.58 720 255.07 720 173.29 507.39",
    style: {
      fill: "#d3d3d3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "605.04 464.87 475.84 464.87 433.32 575.26 580.51 575.26 688.45 538.47 645.93 482.04 605.04 464.87",
    style: {
      fill: "#cfcfcf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "858.53 394.96 938.67 550.73 1051.52 482.04 943.7 0 866.61 0 834 64.19 858.53 394.96",
    style: {
      fill: "#e7e7e7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1125.11 513.93 1197.48 394.96 1051.97 0 943.7 0 1051.52 482.04 1125.11 513.93",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "645.93 482.04 611.17 429.3 605.04 464.87 645.93 482.04",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "798.84 350.87 858.53 394.96 834 64.19 795.01 0 693.45 0 667.6 88.31 798.84 350.87",
    style: {
      fill: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "475.84 464.87 605.04 464.87 611.17 429.3 529 203.61 484.84 375.33 475.84 464.87",
    style: {
      fill: "#d9d9d9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "667.6 88.31 537.58 158.23 798.84 350.87 667.6 88.31",
    style: {
      fill: "#dfdfdf"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "611.17 429.3 645.93 482.04 771.86 646.4 938.67 550.73 858.53 394.96 798.84 350.87 537.58 158.23 529 203.61 611.17 429.3",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "537.58 158.23 514.28 112.84 493.42 141.06 529 203.61 537.58 158.23",
    style: {
      fill: "#dedede"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "322.93 388.82 232.16 482.04 433.32 575.26 475.84 464.87 322.93 388.82",
    style: {
      fill: "#d5d5d5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.53 394.96 363.41 354.54 322.93 388.82 475.84 464.87 461.53 394.96",
    style: {
      fill: "#d6d6d6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "866.61 0 830.17 0 834 64.19 866.61 0",
    style: {
      fill: "#e5e5e5"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "514.28 112.84 537.58 158.23 581.43 0 545.08 0 537.58 14.72 514.28 112.84",
    style: {
      fill: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "484.84 375.33 529 203.61 497.09 294.11 461.53 394.96 475.84 464.87 484.84 375.33",
    style: {
      fill: "#d8d8d8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "529 203.61 493.42 141.06 481.16 158.23 497.09 294.11 529 203.61",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "529 203.61 497.09 294.11 497.09 294.11 529 203.61",
    style: {
      fill: "#ddd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "461.53 394.96 497.09 294.11 481.16 158.23 385.49 256.35 363.41 354.54 461.53 394.96",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "497.09 294.11 461.53 394.96 497.09 294.11 497.09 294.11",
    style: {
      fill: "#dadada"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.1 464.87 232.16 482.04 203.95 421.94 183.1 464.87",
    style: {
      fill: "#d2d2d2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "667.6 88.31 693.45 0 581.43 0 537.58 158.23 667.6 88.31",
    style: {
      fill: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "830.17 0 795.01 0 834 64.19 830.17 0",
    style: {
      fill: "#ececec"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.1 366.75 153.66 247.36 104.6 284.97 82.52 413.36 130.77 482.04 173.29 507.39 183.1 464.87 183.1 366.75",
    style: {
      fill: "#d7d7d7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "183.1 366.75 183.1 464.87 203.95 421.94 232.16 482.04 322.93 388.82 363.41 354.54 385.49 256.35 304.12 203.61 264.87 141.06 183.1 366.75",
    style: {
      fill: "#dcdcdc"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "104.6 284.97 153.66 247.36 183.1 366.75 264.87 141.06 217.44 64.19 122.59 219.59 104.6 284.97",
    style: {
      fill: "#e1e1e1"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "122.59 219.59 217.44 64.19 137.72 137.38 100.92 170.49 82.52 413.36 104.6 284.97 122.59 219.59",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "217.44 64.19 207.61 0 157.58 0 137.72 137.38 217.44 64.19",
    style: {
      fill: "#e9e9e9"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "245.42 0 207.61 0 217.44 64.19 245.42 0",
    style: {
      fill: "#eee"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "385.49 256.35 481.16 158.23 493.42 141.06 514.28 112.84 537.58 14.72 539.26 0 348.37 0 304.12 203.61 385.49 256.35",
    style: {
      fill: "#e8e8e8"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "304.12 203.61 331.49 0 284.35 0 217.44 64.19 304.12 203.61",
    style: {
      fill: "#e2e2e2"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.08 0 540.5 0 537.58 14.72 545.08 0",
    style: {
      fill: "#eaeaea"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.37 0 331.49 0 304.12 203.61 348.37 0",
    style: {
      fill: "#e4e4e4"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMidL);
export default __webpack_public_path__ + "static/media/mid_l.07b5bfb0f3f8d26d38c51df729b4374a.svg";
export { ForwardRef as ReactComponent };